"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADER_ICONS_TYPE = void 0;

var _constants = require("../Icon/constants");

var HEADER_ICONS_TYPE = [_constants.ICON_TYPE_MENU, _constants.ICON_TYPE_LOGIN, _constants.ICON_TYPE_CLOSE, _constants.ICON_TYPE_ARROW, _constants.ICON_TYPE_DELAY, _constants.ICON_TYPE_EXIT];
exports.HEADER_ICONS_TYPE = HEADER_ICONS_TYPE;